import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserSelectorDlgComponent } from 'src/app/chat/dialogs/user-selector-dlg/user-selector-dlg.component';
import {
    EUserSelectorDlgResultStatus,
    IUserSelectorDlgResult,
    IUserSelectorSettings,
} from 'src/app/chat/dialogs/user-selector-dlg/user-selector-dlg.interface';
import {
    ILeadFormDlgResult,
    LeadFormComponent,
    LeadFormDlgDataParams,
} from 'src/app/leads/lead-form/lead-form.component';
import { UserService } from 'src/app/services/user.service';
import { IAction } from '../../../model/action.model';

@UntilDestroy()
@Component({
    selector: 'app-default-action-form',
    templateUrl: './default-action-form.component.html',
    styleUrls: ['./default-action-form.component.scss'],
})
export class DefaultActionFormComponent implements OnInit {
    @Input() subFormIsLoading$: Subject<boolean>;
    @Input() form: FormGroup;
    @Input() action: IAction;

    selectedCustomer = null;
    customers: [];

    constructor(private fb: FormBuilder, public dialog: MatDialog, private userService: UserService) {}

    ngOnInit(): void {
        this.loadFormData().subscribe(() => {
            this.extendFormControls();
            this.subFormIsLoading$.next(false);
        });
    }

    showCreateCustomerDlg() {
        this.dialog
            .open(LeadFormComponent, {
                ...LeadFormDlgDataParams,
            })
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((data: ILeadFormDlgResult) => {
                if (data?.status === true) {
                    this.selectedCustomer = data.lead;
                }
            });
    }

    showSelectCustomerDlg() {
        this.dialog
            .open(UserSelectorDlgComponent, {
                height: '616px',
                width: '390px',
                position: { top: '305px' },
                data: {
                    mode: 'single',
                    userList: this.customers,
                } as IUserSelectorSettings,
            })
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((data: IUserSelectorDlgResult) => {
                if (data?.status === EUserSelectorDlgResultStatus.Selected) {
                    this.selectedCustomer = data.members;
                    this.form.get('customerId').setValue(this.selectedCustomer.id);
                }
            });
    }

    removeCustomer() {
        this.selectedCustomer = null;
        this.form.get('customerId').setValue(null);
    }

    private loadFormData(): Observable<any> {
        return this.userService
            .all()
            .pipe(untilDestroyed(this))
            .pipe(
                tap((res: any) => {
                    this.subFormIsLoading$.next(true);
                    this.customers = res.data
                        .filter((u) => u.accountType !== 'admin')
                        .map((u) => {
                            u.contact = {
                                firstname: u.firstname,
                                surname: u.surname,
                            };
                            return u;
                        });
                })
            );
    }

    private extendFormControls() {
        this.form.addControl('title', new FormControl(this.action.title, Validators.required));
        this.form.addControl('description', new FormControl(this.action.description, Validators.required));
    }
}
